var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMasterBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_192_1",
    "data-name": "Component 192 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7527",
    "data-name": "Rectangle 7527",
    width: 32,
    height: 32,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11541",
    "data-name": "Group 11541",
    transform: "translate(-217 -56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3731",
    "data-name": "Rectangle 3731",
    transform: "translate(228.5 61.771)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 8,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 7.5,
    height: 6.5,
    rx: 0.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12018",
    "data-name": "Path 12018",
    d: "M-1775,15666.506v2.5",
    transform: "translate(2008 -15597.004)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11540",
    "data-name": "Group 11540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11539",
    "data-name": "Group 11539"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3732",
    "data-name": "Rectangle 3732",
    transform: "translate(222 75)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 6.5,
    height: 6.5,
    rx: 0.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3733",
    "data-name": "Rectangle 3733",
    transform: "translate(236 75)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 6.5,
    height: 6.5,
    rx: 0.25,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_12019",
    "data-name": "Path 12019",
    d: "M-1765.081,15670.424v-2.514h-13.972v2.514",
    transform: "translate(2005.081 -15595.424)",
    fill: "none",
    stroke: "#707070",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterBlack);
export default __webpack_public_path__ + "static/media/MasterBlack.4999005bd8cd0069f6cbffd810e7fb11.svg";
export { ForwardRef as ReactComponent };